import { Box } from '@mui/material';
import { msgTypes } from 'constants/msgTypes';
import { FinancialProtectionMessageModel } from 'model/screensModels/FinancialProtectionMessageModel';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import React, { useState } from 'react'
import { DataNotFound } from 'screens/sharedScreens/dataNotFound/DataNotFound';
import { FinancialProtectionMessageService } from 'services/menu/financialProtectionMessage/FinancialProtectionMessageService';
import CreateFinancialProtectionMessage from './CreateFinancialProtectionMessage';
import FinancialProtectionMessageList from './FinancialProtectionMessageList';

const FinancialProtectionMessage = () => {
    const [updateValue, setUpdateValue] = React.useState(new FinancialProtectionMessageModel());
    const [flag, setFlag] = useState(false)
    const [recentGuidelines, setRecentGuidelines] = useState(new FinancialProtectionMessageModel());
  const [isEditMode, setIsEditMode] = useState(false);

    React.useEffect(() => {
        loadRecentGuidelineMessage();
    }, [])

    //Prepare request body 
    const prepareRequest = () => {
        const requestBody = new PaginatorModel();
        requestBody.pageNumber = 0;
        requestBody.pageSize = 1;
        return requestBody;
    }

    //Get recent guidelines list
    const loadRecentGuidelineMessage = async () => {
        const requestBody = prepareRequest();
        const res = await FinancialProtectionMessageService.getFinancialMessageList(requestBody);
        if (res.statusMsg === msgTypes.SUCCESS.msg) {
            if (res?.data !== '') {
                setRecentGuidelines(res?.data?.tbody[0]);
            } else {
                setRecentGuidelines(new FinancialProtectionMessageModel());
            }
        }
    }

    const addFinancialMessage = () => {
        setUpdateValue(new FinancialProtectionMessageModel())
        setIsEditMode(false); // Reset edit mode
        setFlag(true);
    }

    //to get update record value
    const getUpdateRecordValue = (data: FinancialProtectionMessageModel) => {
        setIsEditMode(true);
        setUpdateValue(data);
    }

    const RecentGuidelines = () => {
        return (
            <>
                <h5 className='pb-3 recent-heading'>Recently added Guidelines Message </h5>
                {recentGuidelines.financialProtectionMessageId !== '' ? (
                    <div className='row recent-row'>
                        <div className='col-lg-3 '>
                            <h5>Message : </h5>
                        </div>
                        <div className='col-lg-9'>
                            {recentGuidelines.financialProtectionMessage}
                        </div>
                    </div>
                ) : (
                    <>
                        <DataNotFound message="There is no Guidelines" />
                    </>
                )}
            </>
        )
    }

    return (
        <>
            <Box sx={{ width: '100%' }} className="container container-h-full">
                <Box>
                
                    <div className="content-subheader">
            {!flag ? (
              <h2 className="mr-3 font-weight-bolder">Financial Protection Guidelines Message</h2>
            ) : (
              <h2 className=" font-weight-bolder mr-3">{isEditMode ? 'Edit Financial Protection Guidelines Message' : 'Add Financial Protection Guidelines Message'}</h2>
            )}
            {!flag && <button className="btn primary" onClick={addFinancialMessage}>Add Financial Protection Message</button>}
          </div>
                </Box>

                <>

                    <div >
                        {!flag ?
                            <div className='sub-content-sec recently-blog mb-0 pb-1'>
                                <FinancialProtectionMessageList setFlag={setFlag} updateRecord={getUpdateRecordValue} loadRecentGuidelineMessage={loadRecentGuidelineMessage} />
                            </div>
                            :
                            // <CreateFinancialProtection setFlag={setFlag} updateRecord={updateValue} recordAdded={setRecordAdded} />
                            <div className='container'>
                                <div className='row'>
                                    <div className='col-lg-4 work'>
                                        <div className='sub-content-sec recently-blog'>
                                            <RecentGuidelines />
                                        </div>
                                    </div>
                                    <div className='col-lg-8'>
                                        <div className='sub-content-sec recently-blog'>
                                            <CreateFinancialProtectionMessage setFlag={setFlag} updateRecord={updateValue} loadRecentGuidelineMessage={loadRecentGuidelineMessage} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                </>
            </Box>
        </>
    )
}

export default FinancialProtectionMessage